import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const NotificationsModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=9Ti_VjMj9zk&feature=youtu.be&ab_channel=apadua" />
);

export default NotificationsModal;
